import React from 'react';

import TagsDropdown from './TagsDropdown';

class DefaultDropdown extends React.PureComponent {
  render() {
    return (
      <TagsDropdown
        initialData={{ items: [] }}
        value={null}
        onChange={() => {}}
      />
    );
  }
}

export default DefaultDropdown;
